import React from 'react';
import { Button, Box, Typography, FormGroup, FormControlLabel, Switch, Grid } from '@mui/material';
import { FormData } from '../types';

interface PreferencesStepProps {
  data: Partial<FormData>;
  updateData: (data: Partial<FormData>) => void;
  onBack: () => void;
  onNext: () => void;
}

export const PreferencesStep: React.FC<PreferencesStepProps> = ({
  data,
  updateData,
  onBack,
  onNext,
}) => {
  const handleToggle = (pref: keyof FormData['preferences']) => (event: React.ChangeEvent<HTMLInputElement>) => {
    updateData({
      preferences: {
        emailUpdates: data.preferences?.emailUpdates ?? true,
        productRecommendations: data.preferences?.productRecommendations ?? true,
        newsletter: data.preferences?.newsletter ?? false,
        [pref]: event.target.checked,
      },
    });
  };
  
  // Get preferences with defaults
  const preferences = {
    emailUpdates: data.preferences?.emailUpdates ?? true,
    productRecommendations: data.preferences?.productRecommendations ?? true,
    newsletter: data.preferences?.newsletter ?? false,
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Notification Preferences
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Choose how you'd like to receive updates and notifications from us.
      </Typography>
      
      <FormGroup sx={{ mt: 3, mb: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={preferences.emailUpdates}
                  onChange={handleToggle('emailUpdates')}
                  color="primary"
                />
              }
              label="Email Updates"
              labelPlacement="start"
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                m: 0,
                p: 2,
                bgcolor: 'background.paper',
                borderRadius: 1,
                width: '100%',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={preferences.productRecommendations}
                  onChange={handleToggle('productRecommendations')}
                  color="primary"
                />
              }
              label="Product Recommendations"
              labelPlacement="start"
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                m: 0,
                p: 2,
                bgcolor: 'background.paper',
                borderRadius: 1,
                width: '100%',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={preferences.newsletter}
                  onChange={handleToggle('newsletter')}
                  color="primary"
                />
              }
              label="Subscribe to Newsletter"
              labelPlacement="start"
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                m: 0,
                p: 2,
                bgcolor: 'background.paper',
                borderRadius: 1,
                width: '100%',
              }}
            />
          </Grid>
        </Grid>
      </FormGroup>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
        <Button onClick={onBack}>Back</Button>
        <Button variant="contained" onClick={onNext}>
          Review Details
        </Button>
      </Box>
    </Box>
  );
};

